<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPencilAlt, faTrash, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { isEmpty } from 'lodash';

import { fetchExport } from '@/api/course';
import Pagination from '@/components/Pagination';

library.add( faPencilAlt, faTrash, faSpinner );
// TODO fix hack & slash due to hotfix
export default {
  name: 'ModuleCodeList',
  data() {
    return {
      course: null,
      tag: null,
      deleteCodes: [],
      filterBusy: false,
    };
  },
  components: {
    Pagination,
  },
  computed: {
    ...mapState('code/collection', [
      'items',
      'pagination',
      'isLoading',
    ]),
    ...mapState('course/collection', {
      courses: 'items',
    }),
    ...mapState('tag/collection', {
      tags: 'items',
    }),
    page: {
      get() {
        return this.pagination.page;
      },
      set(page) {
        this.setPage(page);
        const query = Object.assign({}, this.query);

        if (this.course !== null) {
          query.course = this.course;
        }
        this.fetch(query);
      },
    },
    query() {
      const { query } = this.$route;

      if (!query || isEmpty(query)) {
        return null;
      }

      const _query = Object.assign({}, query);

      if (_query.q) {
        _query.query = _query.q;
        delete _query.q;
      }

      if (this.course !== null) {
        _query.course = this.course;
      }

      return _query;
    },
    selectAll: {
      get: function () {
        return this.items ? this.deleteCodes.length == this.items.length : false;
      },
      set: function (value) {
        var selected = [];

        if (value) {
          this.items.forEach(function (item) {
            selected.push(item.id);
          });
        }
        this.deleteCodes = selected;
      }
    },

  },
  watch: {
    query: function(newQuery, oldQuery) {
      if (newQuery === oldQuery) {
        return;
      }
      this.fetch(newQuery);
    },
    course: function(newCourse, oldCourse) {
      if (this.filterBusy) {
        this.filterBusy = false;
        return;
      }
      if (this.tag) {
        this.filterBusy = true;
        this.tag = null;
      }

      const query = Object.assign({}, this.query);

      if (newCourse !== null) {
        query.course = newCourse;
      }

      this.fetch(query);
    },
    tag: function(newTag, oldTag) {
      if (this.filterBusy) {
        this.filterBusy = false;
        return;
      }
      if (this.course) {
        this.filterBusy = true;
        this.course = null;
      }

      const query = Object.assign({}, this.query);

      if (newTag !== null) {
        query.tag = newTag;
      }

      this.fetch(query);
    },
  },
  methods: {
    ...mapActions('code/collection', [
      'fetch',
      'deleteMany',
    ]),
    ...mapActions('course/collection', {
      fetchCourses: 'fetch',
    }),
    ...mapActions('tag/collection', {
      fetchTag: 'fetch',
    }),
    ...mapMutations('code/collection', [
      'setPage',
    ]),
    ...mapActions('code/item', [
      'remove',
    ]),
    confirmDelete(item) {
      this.$dialog.confirm(`Are you sure you want to delete <strong>${item.code}</strong>?`, { loader: true, html: true })
        .then(dialog => this.remove(item.id).then(() => {
          this.fetch().then(() => dialog.close());
        }))
        .catch(() => {})
      ;
    },
    confirmManyDelete() {
      this.$dialog.confirm(`Are you sure you want to delete <strong>${this.deleteCodes.length}</strong> element(s)?`,
        { loader: true, html: true })
        .then(dialog => this.deleteMany(this.deleteCodes).then(() => {
          this.fetch().then(() => dialog.close());
        }))
        .catch(() => {});
    },
    exportCodes() {
      if (!this.course && !this.tag) {
        alert('Course or tag is not selected!');
        return;
      }

      if (this.course) {
        fetchExport(this.course);
      }
      else {
        fetchExport(this.tag, true);
      }

    },
  },
  created() {
    this.fetch(this.query);
    this.fetchCourses();
    this.fetchTag();
  },
};
</script>
<template>
  <div class="box">
    <div class="d-flex justify-content-between mb-3">
      <!-- <h2>Codes</h2> -->
      <div class="actions d-flex">
        <router-link :to="{ name: 'codes-create-bulk' }" class="btn btn-info mr-3 flex-none">
          Generate Bulk Code
        </router-link>
        <router-link :to="{ name: 'codes-create' }" class="btn btn-primary mr-3 flex-none">
          New Code
        </router-link>
        <button @click="exportCodes" class="btn btn-success mr-3 flex-none">
          Export
        </button>
        <button @click="confirmManyDelete" class="btn btn-danger flex-none">
          Delete
        </button>
        <select class="ml-3 form-control" v-model="course">
          <option :value="null">All Courses</option>
          <option v-for="course in courses" :key="course.id" :value="course.id">{{ course.title }}</option>
        </select>
        <select class="ml-3 form-control" v-model="tag">
          <option :value="null">All Tags</option>
          <option v-for="tag in tags" :key="tag.id" :value="tag.id">{{ tag.name }}</option>
        </select>
      </div>
    </div>
    <table>
      <caption>
        <Pagination :pagination="pagination" :type="'codes'" v-model="page"></Pagination>
      </caption>
      <thead>
        <tr>
          <th><input type="checkbox" v-model="selectAll"></th>
          <th>Code</th>
          <th>Days</th>
          <th>Tag</th>
          <th>Activation</th>
          <th>Expiration</th>
          <th class="w-25">Actions</th>
        </tr>
      </thead>
      <tbody>
      <tr v-if="isLoading">
        <td colspan="8" class="text-center">
          <font-awesome-icon icon="spinner" size="3x" spin class="mt-3 mb-3" />
        </td>
      </tr>
      <tr v-else-if="!items.length">
        <td colspan="8" class="text-center">
          There are no courses
        </td>
      </tr>
      <tr v-else v-for="(item, index) in items" :key="item.id" :class="{ primary: index % 2 === 0 }">
        <td><input type="checkbox" :id="item.id" :value="item.id" v-model="deleteCodes" /></td>
        <td>{{ item.code }}</td>
        <td>{{ item.days }}</td>
        <td>{{ item.tag }}</td>
        <td>{{ item.activatedAt }}</td>
        <td>{{ item.expiresAt }}</td>
        <td class="w-25">
          <router-link :to="{ name: 'codes-edit', params: { id: item.id } }" class="mr-3">
            <font-awesome-icon icon="pencil-alt" />
          </router-link>
          <a @click="confirmDelete(item)" class="pointer text-danger">
            <font-awesome-icon icon="trash" />
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
